import { Tabs } from '@/components/ui/daisy';
import { SupportedLanguage } from '@/models/TranslatableField';

type LanguageSelectorProps = {
  activeLanguage: SupportedLanguage;
  onLanguageChange: (lang: SupportedLanguage) => void;
};

export function LanguageSelector({
  activeLanguage,
  onLanguageChange,
}: LanguageSelectorProps) {
  return (
    <Tabs
      value={activeLanguage}
      onChange={lang => onLanguageChange(lang as SupportedLanguage)}
      variant="box"
      size="sm"
    >
      <Tabs.Tab value="pt-br">PT-BR</Tabs.Tab>
      <Tabs.Tab value="en">EN-US</Tabs.Tab>
    </Tabs>
  );
}
